import { h, render } from 'preact';
import NewYearTrack from './new-year-track';

export function renderNewYearTrack(map, routesService, options) {

    render(
        <NewYearTrack options={options} map={map} routesService={routesService} />,
        map.getContainer().parentElement
    );
}